import { pendingTask, begin, end } from 'react-redux-spinner'

const spinnerMiddleware = store => next => action => {
  if (action.type === 'menuData/fetchMenu/pending') {
    store.dispatch({ type: 'SPINNER_BEGIN', [pendingTask]: begin })
  }

  if (action.type === 'menuData/fetchMenu/fulfilled' || action.type === 'menuData/fetchMenu/rejected') {
    store.dispatch({ type: 'SPINNER_END', [pendingTask]: end })
  }

  return next(action)
}

export default spinnerMiddleware
